import { render, staticRenderFns } from "./Site-footer.vue?vue&type=template&id=04fcfd1e&"
import script from "./Site-footer.vue?vue&type=script&lang=js&"
export * from "./Site-footer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports